import { IconComponent } from './types';

const CapexIcon: IconComponent = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="m7.428 5.596-.121.306.232.233 5.297 5.296a.088.088 0 0 1 .028.062.058.058 0 0 1-.019.045l-.01.009-1.34 1.341a.081.081 0 0 1-.116 0L6.065 7.574l-.228-.228-.302.114a3.294 3.294 0 0 1-3.49-.75 3.28 3.28 0 0 1-.737-3.52l-.057 1.017c-.049.86.257 1.736.917 2.39a3.109 3.109 0 0 0 2.658.869 3.04 3.04 0 0 0 1.024-.337l5.236 5.236.355.355.354-.357.513-.52.35-.353-.352-.352-5.221-5.221c.178-.308.301-.642.361-.995.173-.964-.112-2-.862-2.75l-.002-.001a3.13 3.13 0 0 0-2.387-.908l-1.038.058a3.287 3.287 0 0 1 4.271 4.275ZM2.104 3.882l-.766-.766.072-.159L3.193 4.74l.353.353.353-.351.828-.823.356-.353-.354-.355-1.79-1.794c.053-.026.107-.05.16-.072l.77.77 1.45 1.45L3.553 5.33l-1.45-1.45Z"
        stroke="#000"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default CapexIcon;
